import { faker } from "@faker-js/faker";

import type {
  CreateTodo201,
  CreateTodoMutationRequest,
  CreateTodoMutationResponse,
  CreateTodoPathParams,
} from "../models/CreateTodo";
import { createCreateTodoRequest } from "./createCreateTodoRequest";
import { createTodo } from "./createTodo";

export function createCreateTodoPathParams(
  override: NonNullable<Partial<CreateTodoPathParams>> = {},
): NonNullable<CreateTodoPathParams> {
  return {
    ...{ company_id: faker.number.int() },
    ...override,
  };
}

/**
 * @description OK
 */
export function createCreateTodo201(
  override: NonNullable<Partial<CreateTodo201>> = {},
): NonNullable<CreateTodo201> {
  return {
    ...{ data: createTodo() },
    ...override,
  };
}

export function createCreateTodoMutationRequest(
  override?: NonNullable<Partial<CreateTodoMutationRequest>>,
): NonNullable<CreateTodoMutationRequest> {
  return createCreateTodoRequest(override);
}

/**
 * @description OK
 */
export function createCreateTodoMutationResponse(
  override: NonNullable<Partial<CreateTodoMutationResponse>> = {},
): NonNullable<CreateTodoMutationResponse> {
  return {
    ...{ data: createTodo() },
    ...override,
  };
}
